import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { Galleria } from 'primereact/galleria';
import { Carousel } from 'primereact/carousel';
import { classNames } from 'primereact/utils';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Button } from 'primereact/button';
import useWindowDimensions from '../hooks/useDimensions';

function Maps2({ latitud, longitud, descripcion, icon, info }) {

    const [open, setOpen] = useState(false);
    const [mapLoading, setMapLoading] = useState(true);
    const [novelty, setNovelty] = useState({
        images: "",
        icon: "",
        lat: "",
        lon: "",
        name: "",
        audio: "",
        file: "",
    })

    const containerStyles = {
        display: "block",
        maxWidth: "230px",
        maxHeight: "95px",
        width: "auto",
        height: "auto"
    };

    const imgStyles = {
        width: '100%',
        height: '100%',
    };

    function error() {
        console.log("No se puede obtener la localizacion");
    }

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    const { width, height } = useWindowDimensions()
    const isMobile = width <= 768;

    useEffect(() => {
        async function initMap() {
            const { Map } = await window.google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            const markers = []

            const map = new Map(document.getElementById('map'), {
                zoom: isMobile ? 13 : 10,
                // center: center,
                mapId: process.env.REACT_APP_MAPS,
                mapTypeId: 'roadmap',
                gestureHandling: isMobile && 'cooperative',
            });

            map.addListener('tilesloaded', () => {
                setMapLoading(false);
            });

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    const center = {
                        lat: latitud.length > 0 ? latitud[0] : latitude,
                        lng: longitud.length > 0 ? longitud[0] : longitude
                    }
                    map.setCenter(center);
                }, error);
            }

            let marker = {}
            console.log(icon)
            let addedLocations = new Set(); // Almacena las ubicaciones agregadas
            latitud.forEach((mark, index) => {
                const location = { lat: mark, lng: longitud[index] };
                const locationString = `${mark},${longitud[index]}`;

                // Verifica si la ubicación ya ha sido agregada
                if (addedLocations.has(locationString)) {
                    // Desplazamiento aleatorio para evitar superposición
                    const randomOffset = Math.random() / 1500000; // Puedes ajustar el valor según tus necesidades
                    location.lat += randomOffset;
                    location.lng += randomOffset;
                }

                addedLocations.add(locationString);
                if (icon[index] && icon[index]['ICON']) {
                    const imgContainer = document.createElement('div');
                    const img = document.createElement('img');
                    img.src = icon[index] && icon[index]['ICON'];
                    imgContainer.style.width = '40px';
                    imgContainer.style.height = '40px';
                    imgContainer.style.borderRadius = '50%';
                    imgContainer.style.overflow = 'hidden';
                    imgContainer.style.display = 'flex';
                    imgContainer.style.alignItems = 'center';
                    imgContainer.style.justifyContent = 'center';
                    imgContainer.style.background = 'white'
                    imgContainer.style.backgroundColor = 'white'
                    imgContainer.style.border = info && info[index] && info[index]['TYPE'] === 'IN' ? '1px solid green' : info && info[index] && info[index]['TYPE'] === 'OUT' ? '1px solid red' : '1px solid blue'

                    // Aplicar estilos a la imagen
                    // img.style.width = '100%';
                    img.style.height = '100%';

                    // Agregar la imagen al contenedor
                    imgContainer.appendChild(img);
                    marker = new AdvancedMarkerElement({
                        map: map,
                        position: location,
                        title: descripcion[index],
                        content: icon && imgContainer,
                    })
                }
                else {
                    marker = new window.google.maps.Marker({
                        position: location,
                        map: map,
                        title: descripcion[index],
                    });
                }
                marker.addListener("click", (e) => {
                    // Función de zoom in cuando se hace clic en el marcador
                    // map.setZoom(15); // Puedes ajustar este valor según tus necesidades
                    console.log(icon[index])
                    setNovelty({
                        ...novelty,
                        images: icon[index]['DETAIL']['IMAGE'] ? icon[index]['DETAIL']['IMAGE'] : icon[index]['DETAIL'],
                        audio: icon[index]['DETAIL']['AUDIO'] ? icon[index]['DETAIL']['AUDIO'][0] : '',
                        file: icon[index]['DETAIL']['FILE'] ? icon[index]['DETAIL']['FILE'][0] : '',
                        icon: icon[index]['ICON'],
                        lat: mark,
                        lon: longitud[index],
                        name: descripcion[index] ? descripcion[index] : "",
                        type: info[index]['TYPE'] ? info[index]['TYPE'] : "",
                        time: info[index]['TIME'] ? info[index]['TIME'] : "",
                        date: info[index]['DATE'] ? info[index]['DATE'] : "",
                        status: info[index]['STATUS'] ? info[index]['STATUS'] : "",
                        number_id: info[index]['NUMBER_ID'] ? info[index]['NUMBER_ID'] : "",
                        title: info[index]['TITLE'] ? info[index]['TITLE'] : ""
                    })
                    setOpen(info[index]['TYPE'] || icon[index]['DETAIL']['AUDIO'] ? true : false)
                    // map.setCenter(marker.getPosition());
                });
                markers.push(marker)
            });
            if (markers.length > 1) {
                new MarkerClusterer({ markers, map });
            }
        }

        // Llama a la función de inicialización del mapa
        initMap();

        // Agrega la limpieza del mapa si es necesario
        return () => {
            // Limpiar el mapa o realizar otras acciones de limpieza si es necesario
        };
    }, [latitud, longitud, descripcion, icon, info]);

    const itemTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'ACTIVITY'} style={{ width: '100%', display: 'block', maxHeight: '40vh' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'ACTIVITY'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
    }

    const iconStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        backgroundColor: 'white',
        border: novelty && novelty.type === 'IN' ? '1px solid green' : novelty && novelty.type === 'OUT' ? '1px solid red' : '1px solid blue'
    }

    const header = <div className='flex flex-row'>
        <div style={iconStyle}>
            <img src={novelty.icon} alt={novelty.name} style={{ height: '100%' }} />
        </div>
        <span className='ml-6'>{novelty.title}</span>
    </div>

    return (
        <div style={{ position: 'relative', height: '70vh' }}>
            {mapLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f8f9fa',
                    zIndex: 1000,
                    gap: '12px',
                }}>
                    <i className="pi pi-map-marker" style={{ fontSize: '2rem', color: '#6c757d' }} />
                    <span style={{ color: '#6c757d', fontSize: '14px' }}>Cargando mapa...</span>
                </div>
            )}
            <div id="map" style={{ height: '70vh' }} />
            <Dialog visible={open} onHide={() => setOpen(false)} draggable={false} header={header}>
                <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'column' }}>
                    {novelty.images.length > 0 &&
                        <div className='card'>
                            <Galleria value={novelty.images} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px' }}
                                item={itemTemplate} thumbnail={thumbnailTemplate} />
                        </div>
                    }
                    {/* <div className='w-full flex justify-items-start align-items-start flex-column'>
                        <div>
                            <span><label className='font-bold'>Contrato:</label>&nbsp;{novelty.name}</span>
                        </div>
                        <div>
                            <span><label className='font-bold'>Nro documento:</label>&nbsp;{novelty.number_id}</span>
                        </div>
                    </div> */}
                    <table>
                        <tbody>
                            <tr>
                                <td><label className='font-bold'>Contrato:</label>&nbsp;{novelty.name}</td>
                                <td><label className='font-bold'>Nro documento:</label>&nbsp;{novelty.number_id}</td>
                            </tr>
                            <tr>
                                <td><label className='font-bold'>Fecha:</label>&nbsp;{novelty.date}</td>
                                <td><label className='font-bold'>Hora:</label>&nbsp;{novelty.time}</td>
                            </tr>
                            {novelty.type && novelty.status &&
                                <tr>
                                    {novelty.type && <td><label className='font-bold'>Tipo:</label>&nbsp;{novelty.type}</td>}
                                    {novelty.status && <td><label className='font-bold'>Estado:</label>&nbsp;{novelty.status}</td>}
                                </tr>}
                            <tr>
                                <td><label className='font-bold'>Lat:</label>&nbsp;{novelty.lat}</td>
                                <td><label className='font-bold'>Lon:</label>&nbsp;{novelty.lon}</td>
                            </tr>
                            {novelty.audio &&
                                <tr>
                                    <td><label className='font-bold'>Audio</label></td>
                                    <td><AudioPlayer
                                        // autoPlay
                                        src={novelty.audio}
                                        onPlay={e => console.log("onPlay")}
                                    // other props here
                                    /></td>
                                </tr>}
                            {novelty.file &&
                                <tr>
                                    <td><label className='font-bold'>Transcripción</label></td>
                                    <td><Button label="Descargar" onClick={() => window.location.href = novelty.file} /></td>
                                </tr>}
                        </tbody>
                    </table>
                </div>
            </Dialog>
        </div>
    )
}

export default Maps2